import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';

export function NotFoundView() {
  return (
    <Card className="mx-auto max-w-md p-8 text-center">
      <h1 className="text-2xl font-bold">404</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        That route doesn't exist yet.
      </p>
      <Link
        to="/command-center"
        className="mt-4 inline-block text-sm font-medium text-primary underline-offset-2 hover:underline"
      >
        Back to Command Center
      </Link>
    </Card>
  );
}
